<template>
   <div>
      <div class="box">
         <div class="left">
            <u-table ref="plTable" :data="tableData" use-virtual showBodyOverflow="title" :height="leftHeight" showHeaderOverflow="title" :row-height="30" border @row-click="leftRowClick">
               <u-table-column :resizable="true" show-overflow-tooltip prop="bgmCode" label="商品编号" min-width="140" />
               <u-table-column :resizable="true" show-overflow-tooltip prop="bgmName" label="通用名称" min-width="150" />
               <u-table-column :resizable="true" show-overflow-tooltip prop="spec" label="规格" min-width="140" />
               <u-table-column :resizable="true" show-overflow-tooltip prop="manufacturer" label="生产厂商" min-width="140" />
               <u-table-column :resizable="true" show-overflow-tooltip prop="psrgdRecnumber" label="收货数量" min-width="140" />
               <u-table-column fixed="right" label="操作" width="80">
                  <template slot-scope="scope">
                     <el-button type="text" size="small" class="btn" @click="DIclick(scope.row)">DI码</el-button>
                     <el-button type="text" size="small" class="btn" @click="ruleClick(scope.row)">规则</el-button>
                  </template>
               </u-table-column>
            </u-table>
         </div>
         <div class="right">
            <el-form :inline="true" class="demo-form-inline" id="searchBox1" label-width="70px" @submit.native.prevent>
               <el-form-item label="UDI码">
                  <el-input class="UDIcode" v-model="UDIcode" ref="UDIcode" @keyup.enter.native="UDInative('inNum')" placeholder="UDI码"></el-input>
                  <p style="color: red;">扫UDI码</p>
               </el-form-item>
               <!-- <el-form-item label="数量" v-if="scanCodeType!=1">
                  <el-input style="width: 120px;" type="number" ref="inNum" @keyup.enter.native="UDInative('keydown')" @input="UDIinput()" v-model="inNum" placeholder="数量"></el-input>
               </el-form-item> -->
               <el-form-item>
                  <el-radio v-model="scanCodeType" :label="2">箱码</el-radio>
                  <el-radio v-model="scanCodeType" :label="1">盒码</el-radio>
               </el-form-item>

            </el-form>
            <el-form :inline="true" class="demo-form-inline" id="searchBox" label-width="70px" @submit.native.prevent>
               <el-form-item label="批号">
                  <el-input style="width: 130px;" type="text" v-model="UDIobj.batchno" ref="batchno" @keyup.enter.native="nativeClick('prodate')"></el-input>
               </el-form-item>
               <el-form-item label="生产日期">
                  <df-date :isType="true" style="width: 130px;" ref="prodate" :isShowLong="false" :isLongTime="false" :isNull=" true" v-model="UDIobj.prodate" @keyup.enter.native="nativeClick('expidate')"></df-date>
               </el-form-item>
               <el-form-item label="失效日期">
                  <df-date :isType="true" :isShowLong="false" ref="expidate" :isLongTime="false" :isNull=" false" v-model="UDIobj.expidate" @keyup.enter.native="nativeClick('keydown')"></df-date>
               </el-form-item>
               <el-form-item label="序列号">
                  <el-input style="width: 130px;" type="text" v-model="UDIobj.xlh"></el-input>
               </el-form-item>
               <el-form-item label="数量">
                  <el-input style="width: 130px;" type="number" v-model="UDIobj.inNum"></el-input>
               </el-form-item>
               <el-form-item>
                  <el-button type="primary" @click="onSubmit">更新</el-button>
               </el-form-item>
            </el-form>
            <u-table ref="plTable" :data="UDIlist" use-virtual showBodyOverflow="title" :height="rightHeight" showHeaderOverflow="title" @row-click="rowClick" :row-height="30" :row-style="rowStyle" border>
               <u-table-column :resizable="true" show-overflow-tooltip prop="type" label="操作" fixed="left" min-width="80">
                  <template slot-scope="scope">
                     <el-button type="danger" size="mini" @click="delClick(scope.$index)">删除</el-button>
                  </template>
               </u-table-column>
               <u-table-column :resizable="true" type="index" width="50" label="序号" />
               <u-table-column :resizable="true" show-overflow-tooltip prop="type" label="状态" min-width="80">
                  <template slot-scope="scope">
                     <el-tag type="success" size="mini" v-if="scope.row.type&&scope.row.type=='已保存'">{{scope.row.type}}</el-tag>
                     <el-tag type="info" size="mini" v-else>未保存</el-tag>
                  </template>
               </u-table-column>
               <u-table-column :resizable="true" show-overflow-tooltip prop="udiCode" label="UDI码" min-width="600" />
               <u-table-column :resizable="true" show-overflow-tooltip prop="diCode" label="DI码" min-width="200" />
               <u-table-column :resizable="true" show-overflow-tooltip prop="bgmName" label="通用名称" min-width="120" />
               <u-table-column :resizable="true" show-overflow-tooltip prop="batchno" label="批号" min-width="120" />
               <u-table-column :resizable="true" show-overflow-tooltip prop="prodatestr" label="生产日期(字符串)" min-width="120" />
               <u-table-column :resizable="true" show-overflow-tooltip prop="expidatestr" label="有效期(字符串)" min-width="120" />
               <u-table-column :resizable="true" show-overflow-tooltip prop="inNum" label="数量" min-width="90" />
               <u-table-column :resizable="true" show-overflow-tooltip prop="xlh" label="序列号" min-width="120" />
               <u-table-column :resizable="true" show-overflow-tooltip prop="prodate" label="生产日期" min-width="110">
                  <template slot-scope="scope">
                     <span v-if="scope.row.prodate">
                        {{ $moment(new Date(scope.row.prodate)).format('YYYY-MM-DD') }}
                     </span>
                  </template>
               </u-table-column>
               <u-table-column :resizable="true" show-overflow-tooltip prop="expidate" label="有效期" min-width="110">
                  <template slot-scope="scope">
                     <span v-if="scope.row.prodate">
                        {{ $moment(new Date(scope.row.expidate)).format('YYYY-MM-DD') }}
                     </span>
                  </template>
               </u-table-column>

            </u-table>
         </div>
      </div>
      <div class="floor">
         <el-button type="" @click="clearClick" style="margin-right: 20px;">取消</el-button>
         <el-button type="primary" @click="submitClick">保存</el-button>
      </div>
      <!-- 规则配置 -->
      <el-dialog title="规则配置" :visible.sync="ruleShow" width="500px" :modal-append-to-body='true' :append-to-body="true" class="dialogBox1">
         <el-form ref="formBoxs" :model="UDIruleObj" label-width="80px" :inline-message="false" :show-message="false">
            <el-form-item label="批号" prop="batchStart" required>
               <el-input class="input_rule" v-model="UDIruleObj.batchStart">
                  <template slot="prepend">起始位置</template>
               </el-input>
               <el-input class="input_rule" v-model="UDIruleObj.batchDigit">
                  <template slot="prepend">位数</template>
               </el-input>
            </el-form-item>
            <el-form-item label="生产日期" required>
               <el-input class="input_rule" v-model="UDIruleObj.prodateStart">
                  <template slot="prepend">起始位置</template>
               </el-input>
               <el-input class="input_rule" v-model="UDIruleObj.prodateDigit">
                  <template slot="prepend">位数</template>
               </el-input>
            </el-form-item>
            <el-form-item label="有效期" required>
               <el-input class="input_rule" v-model="UDIruleObj.expidateStart">
                  <template slot="prepend">起始位置</template>
               </el-input>
               <el-input class="input_rule" v-model="UDIruleObj.expidateDigit">
                  <template slot="prepend">位数</template>
               </el-input>
            </el-form-item>
            <el-form-item label="序列号" required>
               <el-input class="input_rule" v-model="UDIruleObj.xlhStart">
                  <template slot="prepend">起始位置</template>
               </el-input>
               <!-- <el-input class="input_rule" v-model="UDIruleObj.xlhDigit">
                  <template slot="prepend">位数</template>
               </el-input> -->
            </el-form-item>
         </el-form>
         <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="onRule">保 存</el-button>
         </span>
      </el-dialog>
      <!-- DI码维护 -->
      <el-dialog title="DI码维护" :visible.sync="DIShow" width="500px" :modal-append-to-body='true' :append-to-body="true" class="dialogBox2">
         <el-form label-width="80px" inline @submit.native.prevent>
            <el-form-item label="DI码" prop="diCode">
               <el-input class="input_rule" v-model="diCode" @keyup.enter.native="DInative()"></el-input>
            </el-form-item>
            <el-form-item>
               <el-button type="primary" @click="DInative">添加</el-button>
            </el-form-item>
         </el-form>
         <u-table ref="plTable" :data="DIlist" use-virtual showBodyOverflow="title" :height="400" showHeaderOverflow="title" :row-height="30" border>
            <u-table-column label="序号" type="index" width="100" />
            <u-table-column :resizable="true" show-overflow-tooltip prop="diCode" label="DI码" min-width="120" />
            <u-table-column :resizable="true" show-overflow-tooltip prop="type" label="状态" min-width="120">
               <template slot-scope="scope">
                  <el-button type="danger" @click="delDIClick(scope.$index)">删除</el-button>
               </template>
            </u-table-column>
         </u-table>
         <div class="floor">
            <el-button type="primary" @click="onDI">保 存</el-button>
         </div>
      </el-dialog>
   </div>
</template>

<script>
import axios from 'axios'

export default {
   name: "UDIscanCode",
   props: ['actionData'],
   data() {
      return {
         UDIcode: "",
         scanCodeType: 1,
         inNum: 0,
         tableData: [],
         leftHeight: 0,
         rightHeight: 0,
         UDIlist: [],
         UDIobj: {
            batchno: "",
            prodate: "",
            expidate: "",
            bgmId: "",
            inNum: 0,
            udiCode: "",
            xlh: "",
            diCode: "",
            bgColor: "",
            type: "",
            expidatestr: "",
            expidatestr: "",
            piCode: "",
            prodatestr: "",
         },
         DIShow: false,
         bgmId: "",
         diCode: "",
         DIlist: [],
         selectIndex: 0,
         ruleShow: false,
         form: {
            name: "",
         },
         UDIruleObj: {
            batchDigit: 0,
            batchStart: 0,
            bgmId: 0,
            expidateDigit: 0,
            expidateStart: 0,
            prodateDigit: 0,
            prodateStart: 0,
            // xlhDigit: 0,
            xlhStart: 0
         }
      }
   },
   watch: {
      scanCodeType() {
         if (this.scanCodeType == 1) {
            this.inNum = 1
         } else {
            this.inNum = 0
         }
      }
   },
   created() {
      this.$nextTick(() => {
         this.openBox()
         setTimeout(() => {
            this.$refs['UDIcode'].focus()
            this.heightChange()
         }, 100)
      })
   },
   methods: {
      async leftRowClick(row, column, event) {
         this.UDIlist.forEach(item => {
            if (item.bgmId == row.bgmId) {
               this.$set(item, 'bgColor', '#a7d0fb')
            } else {
               this.$set(item, 'bgColor', '')
            }
         })
      },
      rowClick(row, column, event) {
         this.selectIndex = this.UDIlist.indexOf(row)
         for (const key in this.UDIobj) {
            this.$set(this.UDIobj, key, this.UDIlist[this.selectIndex][key])
         }
      },
      UDIinput() {
         this.$set(this, 'inNum', this.$common.updataNum('inNum', this).inNum)
      },
      UDInative(type) {
         if (this.UDIcode == "") {
            return this.$message.error("请扫UDI码！")
         }
         if (String(this.UDIcode).length <= 18) {
            return
         }
         // if (this.scanCodeType != 1 && type != 'keydown') {
         //    this.$refs[type].focus()
         // } else 

         if (this.scanCodeType != 1) {
            this.UDI(true)
            this.UDIcode = ""
         } else if (type == 'keydown') {
            this.UDI(true)
            this.UDIcode = ""
         } else {
            this.UDI(false)
            this.UDIcode = ""
         }
      },
      async UDI(val) {
         var arr1 = this.UDIlist.filter(val => val.udiCode == this.UDIcode)
         console.log(arr1);

         if (arr1.length > 0) {
            return this.$message.error("该UDI码已扫过！")
         }
         var token = null
         token = sessionStorage.getItem('token')
         axios({
            // 请求地址
            url: `${this.$store.state.webConfig.dataTwo.requestUrl}/pscha/identifyUDI?udiCode=${this.UDIcode}`,
            method: 'POST',
            headers: {
               token: token
            },
         }).then(res => {
            if (res.data.status == 200) {
               var arr = this.tableData.filter(item => item.bgmId == res.data.result.bgmId)
               if (arr.length > 0) {
                  this.UDIlist.push({})
                  for (const key in this.UDIobj) {
                     this.$set(this.UDIlist[this.UDIlist.length - 1], key, res.data.result[key])
                  }
                  if (val) {
                     // this.$set(this.UDIlist[this.UDIlist.length - 1], 'inNum', this.inNum)
                     this.$set(this.UDIlist[this.UDIlist.length - 1], 'inNum', Number(arr[0].packingSpec||0))
                     this.$set(this.UDIlist[this.UDIlist.length - 1], 'businessId', this.actionData.data.psrgmId)
                     this.$set(this.UDIlist[this.UDIlist.length - 1], 'bgmName', arr[0].bgmName)
                  } else {
                     this.$set(this.UDIlist[this.UDIlist.length - 1], 'inNum', 1)
                     this.$set(this.UDIlist[this.UDIlist.length - 1], 'businessId', this.actionData.data.psrgmId)
                     this.$set(this.UDIlist[this.UDIlist.length - 1], 'bgmName', arr[0].bgmName)
                  }
               } else {
                  this.$message.error("该订单暂无该UDI码产品")
               }
            }else{
               this.$message.error(res.data.message)
            }

         })

      },
      openBox() {
         this.tableData = this.actionData.data.pschaSplitDetailAdds
         console.log(this.actionData.UDIlist);

         if (this.actionData.UDIlist.length > 0) {
            this.actionData.UDIlist.forEach(item => {
               var arr = this.tableData.filter(val => val.bgmId == item.bgmId)
               if (arr.length > 0) {
                  this.$set(item, 'bgmName', arr[0].bgmName)
               }
            })
            this.UDIlist = this.actionData.UDIlist
         }
      },
      onSubmit() {
         for (const key in this.UDIobj) {
            this.$set(this.UDIlist[this.selectIndex], key, this.UDIobj[key])
         }
         this.$set(this.UDIlist[this.selectIndex], "type", "")
         setTimeout(() => {
            for (const key in this.UDIobj) {
               this.UDIobj[key] = "";
            }
         }, 100)
      },
      heightChange() {
         var height = document.documentElement.querySelector(".dialogBox").clientHeight
         var topHeight = document.documentElement.querySelector(".dialogBox").querySelector(".el-dialog__header").clientHeight
         var searchHeight = document.documentElement.querySelector(".dialogBox").querySelector("#searchBox").clientHeight
         var searchHeight1 = document.documentElement.querySelector(".dialogBox").querySelector("#searchBox1").clientHeight
         console.log(height, topHeight, searchHeight, searchHeight1);
         this.leftHeight = height - topHeight - 70
         this.rightHeight = height - topHeight - 70 - searchHeight - searchHeight1
      },
      async ruleClick(row) {
         const res = await this.$http.queryGoodUDIrule({ ids: [row.bgmId] })
         if (res.status == 200) {
            if (res.result) {
               for (const key in this.UDIruleObj) {
                  this.$set(this.UDIruleObj, key, res.result[key])
               }
            } else {
               for (const key in this.UDIruleObj) {
                  this.$set(this.UDIruleObj, key, "")
               }
            }
         } else {
            for (const key in this.UDIruleObj) {
               this.$set(this.UDIruleObj, key, "")
            }
         }
         this.UDIruleObj.bgmId = row.bgmId
         this.ruleShow = true
      },
      async onRule() {
         if (this.UDIruleObj.batchStart == "") {
            return this.$message.error("批号起始位置不能为空")
         } else if (this.UDIruleObj.batchDigit == "") {
            return this.$message.error("批号位数不能为空")
         } else if (this.UDIruleObj.prodateStart == "") {
            return this.$message.error("生产日期起始位置不能为空")
         } else if (this.UDIruleObj.prodateDigit == "") {
            return this.$message.error("生产日期位数不能为空")
         } else if (this.UDIruleObj.expidateStart == "") {
            return this.$message.error("有效期起始位置不能为空")
         } else if (this.UDIruleObj.expidateDigit == "") {
            return this.$message.error("有效期位数不能为空")
         } else if (this.UDIruleObj.xlhStart == "") {
            return this.$message.error("序列号起始位置不能为空")
         } 
         // else if (this.UDIruleObj.xlhDigit == "") {
         //    return this.$message.error("序列号位数不能为空")
         // }
         const res = await this.$http.addGoodUDIrule(this.UDIruleObj)
         if (res.status == 200) {
            this.$message.success(res.message)
            this.ruleShow = false
         }
      },
      async DIclick(row) {
         this.DIlist = []
         this.bgmId = row.bgmId
         const res = await this.$http.queryGoodDi({ ids: [this.bgmId] })
         if (res.status == 200) {
            if (res.result.length > 0) {
               this.DIlist = res.result
            } else {
               this.DIlist = []
            }
         } else {
            this.DIlist = []
         }
         this.DIShow = true
      },
      DInative() {
         if (this.diCode == "") {
            return this.$message.error("请输入DI码！")
         }
         var str = this.diCode
         var arr = this.DIlist.filter(item => item.diCode == str)
         if (arr.length == 0) {
            this.DIlist.push({
               bgmId: this.bgmId,
               diCode: str,
            })
         } else {
            this.$message.error("DI码不能重复！")
         }
         this.diCode = ""
      },
      async onDI() {
         const res = await this.$http.addGoodDi(this.DIlist)
         if (res.status == 200) {
            this.$message.success(res.message)
            this.DIShow = false
         }else{
            this.$message.error(res.message)
         }
      },
      nativeClick(type) {
         if (this.UDIobj.prodate == "" && type == 'expidate') {
            this.$refs['prodate'].$el[0].focus()
            return
         }
         if (this.UDIobj.expidate == "" && type == 'keydown') {
            this.$refs['expidate'].$el[0].focus()
            return
         }
         if (type == 'keydown') {

         } else {
            this.$refs[type].$el[0].focus()
         }
      },
      rowStyle({ row, rowIndex }) {
         let rowBackground = {}
         if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
         return rowBackground
      },
      async submitClick() {
         var str = {}
         var flag = false
         this.tableData.forEach(item => {
            let arr = this.UDIlist.filter(val => val.bgmId == item.bgmId)
            if (arr.length > 0) {
               var num = 0
               arr.forEach(val => {
                  num = Number(num) + Number(val.inNum)
               })
               if (item.psrgdRecnumber < num && !flag) {
                  flag = true
                  str = item
                  return
               }
            }
         })
         if (flag) {
            return this.$message.error(`${str.bgmName}的UDI码扫的超出该商品的收货数量！`)
         }
         const res = await this.$http.addUDIputin(this.UDIlist)
         if (res.status == 200) {
            this.$message.success(res.message)
            var list = []
            this.tableData.forEach(item => {
               var arr = this.UDIlist.filter(val => val.bgmId == item.bgmId)
               if (arr.length > 0) {

                  arr.forEach(item => {
                     this.$set(item, 'bgmStr', `${item.bgmId}${item.batchno}${item.prodate}${item.expidate}`)
                  })
                  list.push(...this.mergeByKey(arr, 'bgmStr'))
               }
            })
            console.log(list);

            this.$emit("clearClick", true, list)
         } else {
            this.$message.error(res.message)
         }
      },
      clearClick() { this.$emit("clearClick", false) },
      mergeByKey(arr, key) {
         const temp = {};
         arr.forEach(item => {
            const currentKey = item[key];
            if (temp[currentKey]) {
               temp[currentKey].inNum += item.inNum; // 合并数量
            } else {
               temp[currentKey] = { ...item }; // 深拷贝避免引用问题
            }
         });
         return Object.values(temp);
      },
      delClick(index) {
         for (const key in this.UDIobj) {
            this.UDIobj[key] = "";
         }
         this.UDIlist.splice(index, 1)
      },
      delDIClick(index) {
         this.DIlist.splice(index, 1)
      },
   },
   mounted() {

   }

}
</script>

<style scoped>
.box {
   display: flex;
   align-items: flex-end;
   justify-content: space-between;
   width: calc(98vw - 20px);
}
.left {
   width: calc((98vw - 40px) / 2 - 150px);
}
.right {
   width: calc((98vw - 40px) / 2 + 150px);
}
.UDIcode{
   width: calc((98vw - 40px) / 2 - 150px);
}
.input_rule {
   width: 180px;
   margin-right: 5px;
}
::v-deep #dateinput {
   width: 130px !important;
}
.btn {
   padding: 3px 0 !important;
}
.floor {
   display: flex;
   align-items: center;
   justify-content: center;
   height: 40px;
   line-height: 40px;
}
.dialogBox ::v-deep .el-dialog {
   margin-bottom: 0;
}
</style>